import React, { useState, useEffect } from 'react';
import { Input, Radio, Button, Select } from '../../Forms/Forms';
import fetchApiData from '../../../apiHandlers/fetchApiData';
import CONSTANTS from '../../../Constants'
import { setVeiculeInfos, setEditVehicle, setSelectedForfaitsToStore, setSelectedMandatoryAdditionalForfaitsToStore } from '../../../redux-files/actions/action';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { pushEventToGTM } from '../../../helpers/trackerManager';


const ModelTab = () => {
    const { brand, currentBrand } = CONSTANTS.SITE_CONFIG;
    const vehicleInfo = useSelector(state => state.ndel_store.vehicleInfo)
    const storeSelectedOperations = useSelector(state => state.ndel_store.selectedOperations)
    const editVehicle = useSelector(state => state.ndel_store.editVehicle)
    const [contratService, setContratService] = useState(vehicleInfo.contratService || false) 
    // const [isRedirectTo, setIsRedirectTo] = useState(false)
    const [kilometrageState, setkilometrageState] = useState({ kilometrageInput: vehicleInfo.Mileage || '', kilometrageErrorLabel: '', })
    const [_isMounted, setIsMounted] = useState(false)
    const [allModels, setAllModels] = useState([])
    const [allEngins, setAllEngins] = useState([])
    const [modelInput, setModelInput] = useState(vehicleInfo.ModelCode || '')
    const [enginInput, setEnginInput] = useState(vehicleInfo.MotorCode || '')
    const [modelsNames, setModelsNames] = useState([])
    const [enginsNames, setEnginsNames] = useState([])
    const { kilometrageInput, kilometrageErrorLabel } = kilometrageState
    const navigate = useNavigate();
    useEffect(() => {
        setIsMounted(true)
        loadModels()
        console.log('useEffect run ...')
        // empty dependency array means this effect will only run once (like componentDidMount in classes)
    },
        [_isMounted],
    );
    useEffect(() => {
        if (Object.keys(vehicleInfo).length > 0) loadEngins(modelInput)
    },
        [editVehicle]
    );
    const dispatch = useDispatch()
    const loadModels = () => {

        const MODELS_API = new fetchApiData();
        if (_isMounted) {
            MODELS_API.getModels()
                .then(
                    data => {
                        let modelsTempNames = []
                        modelsTempNames[0] = CONSTANTS.LABELS.vehicule_model_select_option;
                        setAllModels(data.d)
                        data.d.map((item) => {
                            return modelsTempNames[item.Value] = item.Text;
                        });
                        setModelsNames(modelsTempNames)

                    },
                )
                .catch(Error => {
                    console.log('Eror: ', Error);
                    // this.setState({ 'step1Loading': false });
                })
        }
    };
    // this is for loading energie/Motos
    const loadEngins = (modelCode) => {
        console.log('loading engins')
        const ENGIN_API = new fetchApiData();
        ENGIN_API.getEngins(modelCode)
            .then(
                data => {
                    let enginsModifiedNames = [];
                    enginsModifiedNames[0] = CONSTANTS.LABELS.vehicule_model_select_option;
                    if (data.d.length) {
                        setAllEngins(data.d)
                        data.d.map((item) => {
                            return enginsModifiedNames[item.Value] = item.Text;
                        });
                    }
                    setEnginsNames(enginsModifiedNames)
                },
            )
            .catch(Error => {
                console.log('Eror: ', Error)
                //this.setState({ step1Loading: false });
            })
    }
    const setVeiculeInformation = () => {
        if (vehicleInfo.ModelCode !== modelInput || vehicleInfo.MotorCode !== enginInput) {
            storeSelectedOperations.forEach(operation => {
                if (!operation.interventionForfaits[0].isConstructeur) {
                    operation.interventionForfaits[0].SubFunctionList[0].ForfaitList.forEach(forfait => forfait.isChecked = false)
                }
            })
            dispatch(setSelectedForfaitsToStore([]))
            dispatch(setSelectedMandatoryAdditionalForfaitsToStore([]))
        }
        dispatch(setVeiculeInfos({
            BrandCode: currentBrand,
            BrandLabel: brand,
            EnergyLabel: enginsNames[enginInput],
            LCV: false,
            Lcdv: null,
            Mileage: kilometrageInput,
            ModelCode: modelInput,
            ModelLabel: modelsNames[modelInput],
            MotorCode: enginInput,
            MotorLabel: enginsNames[enginInput],
            PC: false,
            Registration: '',
            SerialNumber: '',
            tabNumber: '3',
            contratService: contratService
        }))
        dispatch(setEditVehicle(false))
        navigate(CONSTANTS.SITE_ROUTS.OPERATIONSPAGE)
        pushEventToGTM({
            pageName: 'car-details',
            eventAction: 'Redirection::Internal::Next_step',
            eventLabel: 'model',
            eventCategory: 'content'
          })
    }
    return (
        <div className='vehicule-details-container'>
            <div className='section-registration'>

                <div className='section-form'>
                    <Select
                        label={CONSTANTS.LABELS.vehicule_model_step1}
                        Options={modelsNames}
                        Selected={modelInput}
                        Name="Model"
                        onChange={(e) => {
                            if (e.target.value.trim() != "0") {
                                loadEngins(e.target.value);
                                setModelInput(e.target.value)
                            }

                        }
                        }
                    />
                    <Select
                        label={CONSTANTS.LABELS.vehicule_model_step1_label_energy}
                        Options={enginsNames}
                        Selected={enginInput}
                        Name="engin"
                        onChange={(e) => setEnginInput(e.target.value)
                        }
                    />

                    <Input
                        label={CONSTANTS.LABELS.vehicule_step2_km1}
                        // placeholder={'-Enter'}
                        name={'distance'}
                        onChange={(e) => {
                            if (e.target.value.trim().length && (!(/^[0-9]*$/.test(e.target.value)))) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_numbersonly
                                })

                            }
                            else if (e.target.value.trim().length && (Number(e.target.value) > 999999)) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_limitednumbers
                                })
                            }
                            else if (e.target.value.trim().length && (Number(e.target.value) === 0)) {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: CONSTANTS.LABELS.vehicule_step2_error_zero
                                })
                            }
                            else {
                                setkilometrageState({
                                    ...kilometrageState,
                                    kilometrageInput: e.target.value,
                                    kilometrageErrorLabel: ''
                                })
                            }
                        }}

                        errorLabel={kilometrageErrorLabel}
                        Value={kilometrageInput}
                    />
                    <div className='form-group'>
                        <div className='form-input'>
                            <div className='form-label'>
                                <label tabIndex="0">{CONSTANTS.LABELS.vehicule_step2_warranty}</label>
                            </div>
                            <div className='radio-button-group'>
                                <Radio name='servieContract' id='servieContract-0' label={CONSTANTS.LABELS.vehicule_step2_warranty_no} isChecked={!contratService} onChange={() => setContratService(false)} />
                                <Radio name='servieContract' id='servieContract-1' label={CONSTANTS.LABELS.vehicule_step2_warranty_yes} isChecked={contratService} onChange={() => setContratService(true)} />
                            </div>
                        </div>
                    </div>
                    <div className='form-group'>
                        <Button
                            handlClick={() => {
                                setVeiculeInformation()
                            }}
                            isDisabled={kilometrageInput.length < 1 || kilometrageErrorLabel.length > 1 || enginInput === "0" || enginInput === "" || modelInput === "0" || modelInput === ""}

                        >
                            {CONSTANTS.LABELS.common_v2_continue}
                        </Button>
                        {/* {isRedirectTo && <Redirect to={CONSTANTS.SITE_ROUTS.OPERATIONSPAGE} />} */}
                    </div>
                </div>

            </div>
        </div>
    );
};

export default ModelTab;